import { HelperField } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import * as React from 'react';

import type { MinimalReduxFormPropsT } from 'utils/minimalReduxFormFieldComponentAdapter';

import type { MatchingRuleT, MatchVariableT } from '../../nodeTypes/types';

import styles from './conditionVariableSelector.module.scss';

export type ConditionVariableItemT = {
  name: string;
  item: MatchVariableT;
};

export type ConditionVariableCategoryT = {
  label: string;
  items: ConditionVariableItemT[];
};

export type ConditionVariablesT = ConditionVariableCategoryT[];

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Label text */
  label?: string;
  /** Placeholder */
  placeholder?: string;
  /** Is the field required? */
  required?: boolean;
  /** Is the field disabled? */
  disabled?: boolean;
  /** Variables */
  variables: ConditionVariablesT;
} & MinimalReduxFormPropsT<MatchingRuleT['variable']>;

export class ConditionVarSelector extends React.PureComponent<PropsT> {
  hasError() {
    const { meta } = this.props;
    if (meta?.error) {
      return meta?.touched === true;
    }
    return false;
  }

  getErrorMessage() {
    if (this.hasError()) {
      const { meta } = this.props;
      return meta?.error;
    }
    return undefined;
  }

  @boundMethod
  onChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const { input, variables } = this.props;
    const value = event.target.value;
    const item = variables
      .flatMap((optGroup) => optGroup.items)
      .find((item) => item.item.variableType === value);

    if (item) {
      input.onChange(item.item);
    }
  }

  render() {
    const {
      className,
      input,
      label,
      meta,
      placeholder,
      required,
      disabled,
      variables,
      ...otherProps
    } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    return (
      <div {...otherProps} className={rootClass}>
        <HelperField
          label={label}
          errorMessage={this.getErrorMessage()}
          required={required}
          fieldId={input.name}
        >
          <select
            className={styles.input}
            id={input.name}
            disabled={disabled}
            onChange={this.onChange}
            value={input.value.variableType}
          >
            {!!placeholder && (
              <option hidden value="">
                {placeholder}
              </option>
            )}
            {variables.map((optGroup) => (
              <optgroup key={optGroup.label} label={optGroup.label}>
                {optGroup.items.map((option) => (
                  <option
                    key={option.item.variableType}
                    value={option.item.variableType}
                  >
                    {option.name}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </HelperField>
      </div>
    );
  }
}
